import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Prefill del Cotizador cuando se llega desde la ficha CRM de un prospecto
 * ("Cotizar honorario"): trae los datos del edificio (catastro + correcciones
 * de campo) y habilita "Guardar en prospecto" para registrar el presupuesto en
 * `prospectos_crm`. Se limpia con "Quitar" o al cotizar para otro prospecto.
 */
const Ctx = createContext(null);

export function CotizadorPrefillProvider({ children }) {
  const [prefill, setPrefillState] = useState(null);
  const setPrefill = useCallback((p) => setPrefillState(p || null), []);
  const clearPrefill = useCallback(() => setPrefillState(null), []);
  return <Ctx.Provider value={{ prefill, setPrefill, clearPrefill }}>{children}</Ctx.Provider>;
}

export function useCotizadorPrefill() {
  return useContext(Ctx) || { prefill: null, setPrefill: () => {}, clearPrefill: () => {} };
}
